import { Package, Users } from 'react-feather';

/**
 * Sprint 2 production sidebar.
 *
 * Production users see ONLY:
 *   - Produktionsvy (Sprint 4 - placeholder for now)
 *   - Kundlista in read-only mode (no MRR/prices/pipeline)
 *
 * Notification settings (and the rest of the admin/production tools) now live
 * in the dedicated settings sidebar view (see settingsItems.js).
 */

const leveransSection = {
  title: 'Leverans',
  pages: [
    {
      href: '/produktion/produktionsvy',
      title: 'Produktionsvy',
      icon: Package,
    },
    {
      href: '/produktion/leverans/kundlista',
      title: 'Kundlista',
      icon: Users,
    },
  ],
};

const navItems = [leveransSection];

export default navItems;
